import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const EditIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M14.87 4.576a1.966 1.966 0 0 1 2.78 0l1.774 1.773a1.966 1.966 0 0 1 0 2.78l-9.611 9.612a1 1 0 0 1-.478.266l-4.106.966a1 1 0 0 1-1.202-1.202l.966-4.106a1 1 0 0 1 .266-.478l9.611-9.611Zm1.39 1.438L6.875 15.4l-.53 2.257 2.256-.531 9.386-9.387-1.726-1.725Z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M13.493 6.509a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }));
});
EditIcon.displayName = "EditIcon";
